import '@mantine/core/styles.css';
import { Landing } from './landing/Landing';

function App() {
  return <Landing />;
}

export default App;
